<div class="bk-dialog bk-dialog__event">
	<h4 mat-dialog-title>
		{{'Changes not saved' | translate }}
	</h4>

	<div mat-dialog-content>
		<p>
			{{'The changes you made were not saved. Discard changes?' | translate }}
		</p>
	</div>

	<div mat-dialog-actions align="end">

		<button mat-button
			class="bk-button bk-button--medium
			bk-button--text-only bk-dialog__button--secondary"
			(click)="keep($event)">
			{{'Keep Editing' | translate }}
		</button>
		<button mat-button
			class="bk-button bk-button--medium"
			(click)="discard($event)">
			{{'Discard' | translate }}
		</button>
	</div>
</div>
